export const menus = [
    {
        title: 'Atendimentos',
        path: '/governanceroom/dashboardsiasus/services'
    },
    {
        title: 'Perfil',
        path: '/governanceroom/dashboardsiasus/perfil'
    },
    {
        title: 'Estratificação',
        path: '/governanceroom/dashboardsiasus/stratification',
        gap: true
    },
    {
        title: 'Produção',
        path: '/governanceroom/dashboardsiasus/production'
    }
];
